const STORAGE_KEY = 'store_cart'

const readStorage = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : []
    } catch (e) {
        return []
    }
}

const writeStorage = (items) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
    } catch (e) {
        // kota dolu / gizli mod: sepet yalnızca bellekte kalır
    }
}

const state = () => ({
    items: readStorage(),
})

// getters
const getters = {
    // sepetteki satır sayısı (rozet için)
    count(state) {
        return state.items.length
    },
    total(state) {
        return state.items.reduce((sum, item) => sum + (item.price ?? 0), 0)
    },
    findItem: (state) => (key) => {
        return state.items.find(item => item.key === key) ?? null
    },
}

// actions
const actions = {
    add({state, commit}, {item}) {
        const items = [...state.items]
        const index = items.findIndex(i => i.key === item.key)

        if (index === -1) {
            items.push(item)
        } else if (item.type === 'quantity') {
            // aynı eklentiden tekrar eklendiyse adetleri topla
            const current = items[index]
            const quantity = current.quantity + item.quantity

            items[index] = {
                ...current,
                quantity,
                price: current.unitPrice * quantity,
            }
        } else if (item.type === 'upgrade') {
            // lokasyonlarda seçimler birleşir
            const current = items[index]
            const options = [...new Set([...current.options, ...item.options])]

            items[index] = {
                ...current,
                options,
                price: item.optionPrices
                    ? options.reduce((sum, code) => sum + (item.optionPrices[code] ?? 0), 0)
                    : item.price,
            }
        } else {
            items[index] = item
        }

        commit('setItems', items)
    },

    updateQuantity({state, commit}, {key, quantity}) {
        const items = state.items.map((item) => {
            if (item.key !== key || item.type !== 'quantity') return item

            const safeQuantity = Math.max(1, Math.min(quantity, 99))

            return {
                ...item,
                quantity: safeQuantity,
                price: item.unitPrice * safeQuantity,
            }
        })

        commit('setItems', items)
    },

    remove({state, commit}, {key}) {
        commit('setItems', state.items.filter(item => item.key !== key))
    },

    clear({commit}) {
        commit('setItems', [])
    },
}

// mutations
const mutations = {
    setItems(state, items) {
        state.items = items
        writeStorage(items)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
